import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { render, unmountComponentAtNode } from "react-dom"
import ObjectOverview from "web/components/ObjectOverview"
import React, { Suspense } from "react"

export default class PortfolioObjectOverviewController extends Controller {
  static values = {
    portfolioId: Number,
    selectedOverviewId: Number,
    editPath: String,
    canEdit: Boolean,
  }

  initialize() {
    global.React = React
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <ErrorBoundary>
                <ObjectOverview
                  selectedOverviewId={this.selectedOverviewIdValue}
                  editPath={this.editPathValue}
                  subjectType="portfolio"
                  subjectId={this.portfolioIdValue}
                  canEdit={this.canEditValue}
                />
              </ErrorBoundary>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
